export default __webpack_public_path__ + "static/media/roles_8.e679283c.png";